import "ol/ol.css"
import GeoJSON from "ol/format/GeoJSON"
import Map from "ol/Map"
import VectorLayer from "ol/layer/Vector"
import VectorImageLayer from "ol/layer/VectorImage"
import VectorSource from "ol/source/Vector"
import View from "ol/View"
import { Fill, Stroke, Style } from "ol/style"
import { fromLonLat } from "ol/proj"
import { getAssetUrl } from "./assets"

// 按用户设置(→系统偏好)解析底图配色
export function preferredThemeColor() {
  switch (localStorage.getItem("theme")) {
    case "light":
      return "#F5F5F5"
    case "dark":
      return "#3d3d3d"
    default:
      return window.matchMedia("(prefers-color-scheme: dark)").matches ? "#3d3d3d" : "#F5F5F5"
  }
}

export function baseMapStyle(color = preferredThemeColor()) {
  return new Style({
    fill: new Fill({ color }),
    stroke: new Stroke({ color: "#aaa", width: 1 }),
  })
}

const japanMapVectorSource = new VectorSource({
  url: getAssetUrl("data/gadm36_JPN_2.json"),
  format: new GeoJSON(),
})

const japanEEWMapVectorSource = new VectorSource({
  url: getAssetUrl("data/eew.json"),
  format: new GeoJSON(),
})

const jmaEQVectorSource = new VectorSource({
  url: getAssetUrl("data/jma_eq_area.json"),
  format: new GeoJSON(),
})

const japanPrefVectorSource = new VectorSource({
  url: getAssetUrl("data/prefectures.json"),
  format: new GeoJSON(),
})

const worldVectorSource = new VectorSource({
  url: getAssetUrl("data/world.json"),
  format: new GeoJSON(),
})

export const japanDetailedMapLayer = new VectorImageLayer({
  source: japanMapVectorSource,
  style: baseMapStyle(),
})
japanDetailedMapLayer.set("name", "japan_detailed_map")

export const japanSimpleMapLayer = new VectorImageLayer({
  source: jmaEQVectorSource,
  style: baseMapStyle(),
})
japanSimpleMapLayer.set("name", "japan_simple_map")

export const japanEEWMapLayer = new VectorImageLayer({
  source: japanEEWMapVectorSource,
  style: baseMapStyle(),
})
japanEEWMapLayer.set("name", "japan_eew_map")

export const japanPrefMapLayer = new VectorImageLayer({
  source: japanPrefVectorSource,
  style: baseMapStyle(),
})
japanPrefMapLayer.set("name", "japan_pref_map")

export const worldMapLayer = new VectorImageLayer({
  source: worldVectorSource,
  style: baseMapStyle(),
})
worldMapLayer.set("name", "world_map")

// 应用内唯一的地图实例。创建时不绑定 DOM,由 MapController 在组件挂载时 setTarget,
// Turbo 导航后复用同一实例,避免重复创建。
export const map = new Map({
  layers: [
    new VectorLayer({
      source: worldVectorSource,
      style: baseMapStyle(),
    }),
  ],
  view: new View({
    center: fromLonLat([140.412029876442, 37.3914691547508]), // initial value
    zoom: 8,
  }),
  controls: [],
})

map.addLayer(worldMapLayer)
map.addLayer(japanEEWMapLayer)

window.map = map

export function bindMapTarget(target) {
  map.setTarget(target || undefined)
}

export function unbindMapTarget() {
  map.setTarget(undefined)
}

// 报告渲染产生的动态图层名
const reportLayerNames = ["shindo", "tsunami_warning", "eew", "p_wave", "s_wave"]

// 仅移除报告渲染产生的动态图层(切换报告时用)
export function clearReportLayers() {
  const layers = map.getLayers().getArray().slice()
  for (const layer of layers) {
    if (reportLayerNames.includes(layer.get("name"))) map.removeLayer(layer)
  }
}

// 移除报告图层和各日本区域图层,恢复到初始加载状态(离开地图页时用)
export function resetToBaseLayers() {
  clearReportLayers()
  for (const layer of [japanSimpleMapLayer, japanDetailedMapLayer, japanPrefMapLayer]) {
    map.removeLayer(layer)
  }
  if (!map.getLayers().getArray().includes(worldMapLayer)) map.addLayer(worldMapLayer)
  if (!map.getLayers().getArray().includes(japanEEWMapLayer)) map.addLayer(japanEEWMapLayer)
}

// 主题切换时统一刷新各底图图层配色(bs-theme 调用)
export function applyMapStyle(color) {
  const style = baseMapStyle(color)
  for (const layer of [
    worldMapLayer,
    japanSimpleMapLayer,
    japanDetailedMapLayer,
    japanEEWMapLayer,
    japanPrefMapLayer,
  ]) {
    layer.setStyle(style)
  }
}

export default map
